import all from './all';
import items from './items';
import store from './store';
import bulkStore from './bulkStore';
import show from './show';
import update from './update';
import destroy from './destroy';

export default {
  all,
  items,
  store,
  bulkStore,
  show,
  update,
  destroy,
};



// WEBPACK FOOTER //
// ./src/app/services/recipeIngredience/index.js